import React, { useState } from "react";
import style from "./Sales.module.scss";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";
import SalesSplineChart from "./SalesSplineChart";
import CardComparisonChart from "./CardComparison";
import BatchData from "./SalesTabs/BatchData";
import CardSummary from "./SalesTabs/CardSummary";
import Interchange from "./SalesTabs/InterChange";
import Deposit from "./SalesTabs/Deposit";
import MobileDesktopAlert from "../../../../components/MobileDesktopAlert";
import useCommonStore from "../../../../stores/common";

function Sales() {
  const sliding_tab_options = ["Volume", "Count"];
  const [selectedTab, setSelectedTab] = useState("Batch Data");
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const [type, setType] = useState("volume");
  const dateRange = useCommonStore((state) => state.dateRange);

  return (
    <div className={style.sales_section}>
      <div className={`${style.charts} ${expandDetails ? style.expanded : ""}`}>
        <div className={style.sales_volume}>
          <div className={style.head}>
            <h5>Sales Volume</h5>
            <SlidingTab options={sliding_tab_options} onChange={(e) => setType(e == "Volume" ? "volume" : "count")} />
          </div>
          <SalesSplineChart 
            type={type}
            startDate={dateRange?.startDate}
            endDate={dateRange?.endDate}
          />
        </div>

        <div className={style.card_comparison}>
          <div className={style.head}>
            <h5>Cards comparison</h5>
          </div>
          <CardComparisonChart />
        </div>
      </div>

      <div className={style.tab_data}>
        <SlidingTab
          options={["Batch Data", "Card Summary", "Interchange", "Deposit"]}
          onChange={(e) => setSelectedTab(e)}
        />

        {selectedTab == "Batch Data" && <BatchData />}

        {selectedTab == "Card Summary" && <CardSummary />}

        {selectedTab == "Interchange" && <Interchange />}

        {selectedTab == "Deposit" && <Deposit />}
      </div>

      <MobileDesktopAlert message="See more details on the desktop version" />
    </div>
  );
}

export default Sales;
